<script setup lang="ts">
import { AppSelect } from '@shared/ui/selects'

import {
  useSelectSubstitutionReason,
} from '../../../../model/additional-info/support/info-substitute-tutor/select-substitution-reason.hook'

defineOptions({
  name: 'SelectSubstitutionReason',
})

const {
  placeholder,
  model,
  options,
} = useSelectSubstitutionReason()
</script>

<template>
  <AppSelect
    v-model="model"
    :options="options"
    :placeholder="placeholder"
  />
</template>
